
import { gql } from "@apollo/client";





export const USER_MANAGER_UPDATE_USER = gql`
    mutation userManagerUpdateUser($data: UserManagerUpdateUserInput) {
        userManagerUpdateUser(data: $data) {
            success
            error
        }
    }
`;


export const USER_MANAGER_CREATE_USER = gql`
    mutation userManagerCreateUser($data: UserManagerCreateUserInput) {
        userManagerCreateUser(data: $data) {
            success
            error
        }
    }
`;



export const USER_GET_RULES_QUERY = gql`query getRules {
    getRules {
        id
        name
        details
    }
}`;
export const USER_GET_RULE_DATA_QUERY = gql`query getRuleData ($id: Int!) {
    getRuleData(id: $id) {
        id
        name
        details
    }
}`;

export const USER_MANAGER_GRID_MATRIX_QUERY = gql`query getUserRoleMatrix {
    getUserRoleMatrix {
        id
        user_id
        role_id
        users {
            id
            name
            email
        }
        roles {
            id
            name
            color
            details
        }
    }
}
`;


export const USER_MANAGER_UPDATE_ROLE_ADD_RULE = gql`
    mutation userManagerAddRuleToRole($data: UserManagerAddRuleToRoleInput) {
        userManagerAddRuleToRole(data: $data) {
            success
            error
        }
    }
`;
export const USER_MANAGER_UPDATE_ROLE_REMOVE_RULE = gql`
    mutation userManagerRemoveRuleFromRole($data: UserManagerRemoveRuleFromRoleInput) {
        userManagerRemoveRuleFromRole(data: $data) {
            success
            error
        }
    }
`;

export const USER_MANAGER_UPDATE_USER_ADD_RULE = gql`
    mutation userManagerAddRuleToUser($data: UserManagerAddRuleToUserInput) {
        userManagerAddRuleToUser(data: $data) {
            success
            error
        }
    }
`;
export const USER_MANAGER_UPDATE_USER_REMOVE_RULE = gql`
    mutation userManagerRemoveRuleFromUser($data: UserManagerRemoveRuleFromUserInput) {
        userManagerRemoveRuleFromUser(data: $data) {
            success
            error
        }
    }
`;


export const USER_GET_ROLES_QUERY = gql`query getRoles {
    getRoles {
        id
        name
        color
        details
        role_rules {
            id
            role_id
            rule_id
            rules {
                id
                name
                details
            }
        }
    }
}`;
export const USER_GET_ROLE_DATA_QUERY = gql`query getRoleData ($id: Int!) {
    getRoleData (id: $id) {
        id
        name
        color
        details
        role_rules {
            id
            role_id
            rule_id
            rules {
                id
                name
                details
            }
        }
    }
}`;


export const USER_MANAGER_UPDATE_USER_ADD_ROLE = gql`
    mutation userManagerAddRoleToUser($data: UserManagerAddRoleToUserInput) {
        userManagerAddRoleToUser(data: $data) {
            success
            error
        }
    }
`;
export const USER_MANAGER_UPDATE_USER_REMOVE_ROLE = gql`
    mutation userManagerRemoveRoleFromUser($data: UserManagerRemoveRoleFromUserInput) {
        userManagerRemoveRoleFromUser(data: $data) {
            success
            error
        }
    }
`;
export const USER_MANAGER_CREATE_ROLE = gql`
    mutation userManagerCreateRole($data: UserManagerCreateRoleInput) {
        userManagerCreateRole(data: $data) {
            success
            error
            data {
                roleId
            }
        }
    }
`;
export const USER_MANAGER_CREATE_RULE = gql`
    mutation userManagerCreateRule($data: UserManagerCreateRuleInput) {
        userManagerCreateRule(data: $data) {
            success
            error
            data {
                ruleId
            }
        }
    }
`;

export const USER_MANAGER_UPDATE_RULE = gql`
    mutation userManagerUpdateRule($data: UserManagerUpdateRuleInput) {
        userManagerUpdateRule(data: $data) {
            success
            error
        }
    }
`;
export const USER_MANAGER_UPDATE_ROLE = gql`
    mutation userManagerUpdateRole($data: UserManagerUpdateRoleInput) {
        userManagerUpdateRole(data: $data) {
            success
            error
        }
    }
`;

export const USERS_GET_QUERY = gql`query allUsers {
    allUsers {
        id
        name
        email
        status
        visited
        color
    }
}`;
export const USER_GET_USER_QUERY = gql`query getUserData($id: Int!) {
    getUserData (id: $id) {
        id
        name
        email
        status
        visited
        registered
        details
        user_roles {
            id
            user_id
            role_id
            roles {
                id
                name
                color
                details
                role_rules {
                    id
                    role_id
                    rule_id
                    rules {
                        id
                        name
                        details
                    }
                }
            }
        }
        user_rules {
            id
            user_id
            rule_id
            rules {
                id
                name
                details
            }
        }
    }
}`